import { useState } from "react";
import { useNotify, useRedirect, useStore } from "react-admin";
import SendIcon from "@mui/icons-material/Send";
import ListIcon from "@mui/icons-material/List";
import { Typography, Button } from "@mui/material";

import FormModal from "server/components/Modals/FormModal";
import { POSTGRADUATE_COURSES, SpecialistServicePath } from "utils/constants";
import { specialistRequests } from "api/specialistApi";
import dataProvider from "server/dataProvider";
import { POSTGRADUATE_FILTERS_KEY } from "../List";

const FinalizationYearModal = ({ isSmall }) => {
  const [loading, setLoading] = useState(false);
  const redirect = useRedirect();
  const notify = useNotify();

  // Reads/writes the committed year directly from the shared store — no props needed.
  const [filters, setFilters] = useStore(POSTGRADUATE_FILTERS_KEY, null);
  const year = filters?.year;

  const handleModalConfirm = async () => {
    setLoading(true);
    try {
      await dataProvider.customRequest(specialistRequests.finalizePostgraduateCoursesYear(Number(year)), {}, "POST");
      notify("Финализиране изпълнено успешно.", { type: "success" });
      setFilters({ year: Number(year) });
    } finally {
      setLoading(false);
    }
  };

  const handleModalRedirect = () => {
    redirect(`/${SpecialistServicePath}${POSTGRADUATE_COURSES}/all?Year=${year}`);
  };
  return (
    <FormModal
      titleContent="Финализиране на следдипломни курсове"
      onConfirm={handleModalConfirm}
      triggerButton={
        <Button
          variant="contained"
          color="secondary"
          startIcon={<SendIcon />}
          sx={{
            position: !isSmall ? "absolute" : "relative",
            top: !isSmall ? "3rem" : "auto",
            right: !isSmall ? "1rem" : "auto",
            color: "#fff",
            padding: ".7rem 1.1rem",
            width: "max-content",
            height: "max-content",
            boxShadow: "0.5em 0.5em  #ffffff22, 0.5em 0.5em  .4em rgba(47, 45, 52, 0.33)",
          }}
        >
          Финализирай
        </Button>
      }
      saveTitle={loading ? "Обработка..." : "Потвърди"}
      closeTitle="Отказ"
      confirmEnabled={!loading}
    >
      <Typography sx={{ mb: 2, fontWeight: "bold", textAlign: "center", fontSize: "14px" }}>
        Сигурни ли сте, че искате да финализирате курсовете за година {year}?
      </Typography>
      <Button
        onClick={handleModalRedirect}
        variant="outlined"
        color="success"
        sx={{ mt: 1, justifyContent: "center", display: "flex", marginX: "auto" }}
        startIcon={<ListIcon />}
      >
        Преди това към списъка
      </Button>
    </FormModal>
  );
};
export default FinalizationYearModal;
